// extracted by mini-css-extract-plugin
module.exports = {"list":"EventsList_list__xRAOV","card":"EventsList_card__FFR67","title":"EventsList_title__KjkzN"};